module.exports = __webpack_public_path__ + "static/media/YashMv2.299a8f01.png";